// Utilidades de formato compartidas por las pantallas (datos REALES).

export const fmt = (n) => Number(n || 0).toLocaleString('es-CO');

export const plural = (n, uno, varios) => `${fmt(n)} ${n === 1 ? uno : varios}`;

export const moneda = (n) =>
  new Intl.NumberFormat('es-CO', { style: 'currency', currency: 'COP', maximumFractionDigits: 0 }).format(Number(n || 0));

/** 'YYYY-MM-DD' (o ISO) → fecha local, sin el desfase de un día que provoca `new Date('YYYY-MM-DD')` en Colombia. */
export const fecha = (f) => {
  if (!f) return '';
  const [y, m, d] = String(f).slice(0, 10).split('-').map(Number);
  return new Date(y, m - 1, d).toLocaleDateString('es-CO');
};

const MESES = ['ene', 'feb', 'mar', 'abr', 'may', 'jun', 'jul', 'ago', 'sep', 'oct', 'nov', 'dic'];
/** '2026-09' → 'sep 26' */
export const etiquetaMes = (yyyyMm) => {
  const [y, m] = String(yyyyMm).split('-').map(Number);
  return `${MESES[m - 1] || ''} ${String(y).slice(2)}`;
};

/** Fecha de hoy como 'YYYY-MM-DD' en hora local (para <input type="date"> y para el backend). */
export const hoy = () => {
  const d = new Date();
  return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}-${String(d.getDate()).padStart(2, '0')}`;
};

/** 'YYYY-MM' del mes actual (períodos de nómina). */
export const mesActual = () => hoy().slice(0, 7);
